import { GET_LEAVE_SUMMARY } from "./types";
// !!!
export const getLeaveSummaryRequest = (employeeId: number | string) => {
  return {
    type: GET_LEAVE_SUMMARY.GET_LEAVE_SUMMARY_REQUEST,
    payload: { data: employeeId },
  } as const;
};

export const getLeaveSummarySuccess = (data: any[]) => {
  return {
    type: GET_LEAVE_SUMMARY.GET_LEAVE_SUMMARY_SUCCESS,
    payload: { data },
  } as const;
};

export const getLeaveSummaryFailed = () => {
  return {
    type: GET_LEAVE_SUMMARY.GET_LEAVE_SUMMARY_FAILED,
  } as const;
};

export type LeavesSummaryActions =
  | ReturnType<typeof getLeaveSummaryRequest>
  | ReturnType<typeof getLeaveSummarySuccess>
  | ReturnType<typeof getLeaveSummaryFailed>;
